import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { languages } from 'i18n/options';
import useUniqueId from 'hooks/useUniqueId';
import { getTypedSelectComponents, OptionsDivider } from 'components/Select';
import FormField from 'components/FormField';
var _getTypedSelectCompon = getTypedSelectComponents(),
  Select = _getTypedSelectCompon.Select,
  Option = _getTypedSelectCompon.Option;
var LanguageField = function LanguageField(_ref) {
  var _ref$horizontal = _ref.horizontal,
    horizontal = _ref$horizontal === void 0 ? true : _ref$horizontal,
    id = _ref.id,
    value = _ref.value,
    _ref$menuPlacement = _ref.menuPlacement,
    menuPlacement = _ref$menuPlacement === void 0 ? 'top' : _ref$menuPlacement,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'transparent' : _ref$variant,
    onChange = _ref.onChange,
    hasAutoOption = _ref.hasAutoOption,
    description = _ref.description,
    descriptionType = _ref.descriptionType,
    isDisabled = _ref.isDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  function changeLanguage(newLocale) {
    onChange(newLocale === 'auto' ? null : newLocale);
  }
  return /*#__PURE__*/React.createElement(FormField, {
    as: "span",
    label: t('form_language'),
    labelId: uniqueId,
    horizontal: horizontal,
    description: description,
    descriptionType: descriptionType
  }, /*#__PURE__*/React.createElement(Select, {
    icon: "globe",
    labelledById: uniqueId,
    size: "medium",
    variant: variant,
    menuPlacement: menuPlacement,
    value: value || 'auto',
    onChange: changeLanguage,
    ml: variant === 'transparent' ? '-xxs' : 0,
    isDisabled: isDisabled
  }, hasAutoOption && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Option, {
    value: "auto"
  }, t('language_auto')), /*#__PURE__*/React.createElement(OptionsDivider, null)), languages.map(function (value) {
    return /*#__PURE__*/React.createElement(Option, {
      key: value.value,
      value: value.value
    }, value.title);
  })));
};
export default LanguageField;